import {
  getUserRepository,
  getUsersRepository,
  listAccountsRepository,
  updateUserRepository,
} from '../Infrastructure/Users.repository';

export function getUsersLogic(params) {
  return getUsersRepository(params);
}
export function getUserLogic(id) {
  return getUserRepository(id);
}

export function listAccountsLogic(email) {
  return listAccountsRepository(email);
}

export function updateUserLogic(selected, values) {
  const data = {
    cellphone: values.cellphone,
    phone: values.phone,
    email: values.email,
    type_account: values.type_account,
  };

  // Manejar el rol partner
  if (Object.prototype.hasOwnProperty.call(values, 'is_partner')) {
    data.is_partner = values.is_partner;
  }

  return updateUserRepository(selected.id, data);
}
